import { render, staticRenderFns } from "./CreateItem.vue?vue&type=template&id=2dcc8d6d&scoped=true"
import script from "./CreateItem.vue?vue&type=script&lang=js"
export * from "./CreateItem.vue?vue&type=script&lang=js"
import style0 from "./CreateItem.vue?vue&type=style&index=0&id=2dcc8d6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc8d6d",
  null
  
)

export default component.exports